import { get } from "lodash-es";
import React from "react";
import { classnames } from "../../utils/text";

const Radio = ({
  field,
  form,
  onChange,
  label,
  value,
  idx,
  disabled,
  className,
}) => {
  return (
    <>
      <input
        className={classnames("data-component-radio", className)}
        id={`radio-${field.key}-${idx || 0}`}
        type="radio"
        name={field.key}
        // defaultChecked={field.defaultChecked === value}
        checked={field.defaultChecked === value || (get(form, field.key) && value === get(form, field.key))}
        value={value}
        onChange={get(field, "onChange") || onChange}
        disabled={disabled}
      />
      <label
        className="data-component-radio-label"
        htmlFor={`radio-${field.key}-${idx || 0}`}
      >
        {label}
      </label>
    </>
  );
};
export default Radio;
